/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSendFormToSimilarOffersModel,
  ISendFormToSimilarOffersRequest,
  IMappers,
  ISendFormToSimilarOffersResponse,
  ISendFormToSimilarOffersResponseError,
  TSendFormToSimilarOffersResponse,
} from './types';

const defaultConfig: TSendFormToSimilarOffersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'deal-rent-announcements',
  pathApi: '/v1/send-form-to-similar-offers/',
  hostType: 'api',
} as TSendFormToSimilarOffersModel;

function createSendFormToSimilarOffersModel(
  parameters: ISendFormToSimilarOffersRequest,
): TSendFormToSimilarOffersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendFormToSimilarOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISendFormToSimilarOffersRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSendFormToSimilarOffers<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISendFormToSimilarOffersOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSendFormToSimilarOffersResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSendFormToSimilarOffersModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendFormToSimilarOffersResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISendFormToSimilarOffersResponseError);
    }
  }

  return { response, statusCode } as TSendFormToSimilarOffersResponse;
}

export { defaultConfig, createSendFormToSimilarOffersModel, fetchSendFormToSimilarOffers };
